import { z } from "zod";
import { common } from "../common";

export const canvasVariationGetSchema = z.object({
  id: common.objectId,
  name: z.string(),
  api_variation_id: common.uuid.nullable(),
  first_canvas_step_id: common.objectId.nullable(),
  first_step_ids: z.array(
    common.objectId.nullable() // null: 82 (0.07%)
  ),
  is_control: z.boolean(),
  send_percentage: z.int(),
});
